// Mock data for Taner Torun Personal Website

export const trainings = [
  {
    id: 1,
    title: "Zihinsel Değişim ve Dönüşüm",
    subtitle: "Online Eğitim",
    description: "Bilinçaltınızı yeniden programlayın, zihinsel gücünüzü keşfedin ve hayatınızı dönüştürün. Modern hipnoz teknikleri ile kalıcı değişim.",
    image: "https://images.unsplash.com/photo-1696453423785-727e165462c1?w=1200&q=80",
    date: "18-19-20-21 Aralık 2025",
    time: "21:00 - 24:00",
    duration: "4 Gün, Toplam 12 Saat",
    place: "Online (Zoom)",
    price: 15000,
    originalPrice: 25000,
    type: "Online",
    features: [
      "Zihinsel Sabotaj Kodlarını Kırma",
      "Mali Termostat Sıfırlama Teknikleri",
      "Bilinçaltı Sunucusuna Stratejik Sızma",
      "Bağımlılık Zincirini Kesme Yöntemleri",
      "Yetersizlik Kodunu Kalıcı Parçalama",
      "Hipnotik Dil Kalıpları Ustası Olma"
    ],
    detailedProgram: {
      day1: {
        title: "1. GÜN - Kontrol Panelini Kırma",
        modules: [
          {
            time: "21:00 - 21:45",
            duration: "45 Dk",
            title: "MODÜL 1: Kendini Sabotajın Gizli Kodları",
            description: "Sistem tanı ve sorunu rasyonelleştirme",
            topics: [
              "Sessizliği Kırma ve zihninizdeki geveze sesi susturma",
              "Termostat Laneti: Mali termostatınızın ayarını sıfırlama",
              "Ferrari Etkisi: Kalıcı yazılım değişikliği"
            ]
          },
          {
            time: "21:45 - 23:15",
            duration: "90 Dk",
            title: "MODÜL 2: Bilinçaltı Sunucusuna Sızma (The Purge)",
            description: "Derin dönüşüm ve kök inanç temizliği",
            topics: [
              "Bağımlılık Zinciri: Zehirli kimyasalları kesme",
              "Cam Kırma Töreni: Yetersizlik kodunu parçalama",
              "Veda ve Devir: Mimar kimliğine geçiş"
            ]
          },
          {
            time: "23:15 - 24:00",
            duration: "45 Dk",
            title: "MODÜL 3: Avatar Yaratımı (Bölüm 1)",
            description: "Kimliği yükseltme",
            topics: [
              "Süper-Benlik Mimarisi: Karşı konulmaz alter ego tasarlama",
              "Termostat Hack'i: Yeni zihniyet yükleme"
            ]
          }
        ]
      },
      day2: {
        title: "2. GÜN - Yeniden Programlama ve Karar Mekanizmaları",
        modules: [
          {
            time: "21:00 - 21:45",
            duration: "45 Dk",
            title: "MODÜL 3: Avatar Yaratımı (Bölüm 2)",
            description: "Hızlı uygulama",
            topics: [
              "Yoda Rolü: Kaçınılmaz rehber konumuna yükselme",
              "Pratik uygulamalar ve pekiştirme"
            ]
          },
          {
            time: "21:45 - 23:00",
            duration: "75 Dk",
            title: "MODÜL 4: Kararları Kimin Verdiğini Anlama",
            description: "Gizli mekanizmalar ve sezgisel okuma",
            topics: [
              "Otopilot Kaptanı: Beynin 6 temel dilini okuma",
              "Efsanevi Çilingir: En zor kapıları açma tekniği",
              "Sürüngen Beyin: Nöro-dil kalıpları"
            ]
          },
          {
            time: "23:00 - 24:00",
            duration: "60 Dk",
            title: "MODÜL 5: Bilinçaltına Fısıldama (Bölüm 1)",
            description: "Hipnotik sızma",
            topics: [
              "Nöbetçiyi Atlatma Protokolü: Eleştirel zihni bypass",
              "Gömülü Komutlar: Bilinçaltı emirleri gönderme"
            ]
          }
        ]
      },
      day3: {
        title: "3. GÜN - Otorite ve Güç",
        modules: [
          {
            time: "21:00 - 21:45",
            duration: "45 Dk",
            title: "MODÜL 5: Bilinçaltına Fısıldama (Bölüm 2)",
            description: "Gömülü komutlar",
            topics: [
              "Ön Kabul Köprüsü: Dirençsiz sahiplik hissi",
              "Pratik uygulamalar"
            ]
          },
          {
            time: "21:45 - 23:00",
            duration: "75 Dk",
            title: "MODÜL 6: Otorite ve Güç - Çerçeveleme Protokolü",
            description: "Masadaki güç dinamiklerini ele geçirme",
            topics: [
              "Görünmez Güç Savaşı: Çerçeve savaşını kazanma",
              "3 Tuzağın İmhası: Alfa cevaplarla tuzakları tersine çevirme",
              "Siz Ödülsünüz: Kovalanan taraf olma sanatı"
            ]
          },
          {
            time: "23:00 - 24:00",
            duration: "60 Dk",
            title: "MODÜL 7: FBI Müzakere (Bölüm 1)",
            description: "Gizli bilgi ve müzakere",
            topics: [
              "FBI Taktiksel Empati: Siyah Kuğu metodu",
              "7-38-55 Yalan Dedektörü: Beden dili analizi"
            ]
          }
        ]
      },
      day4: {
        title: "4. GÜN - Zirve ve Büyük Final",
        modules: [
          {
            time: "21:00 - 21:45",
            duration: "45 Dk",
            title: "MODÜL 7: FBI Müzakere (Bölüm 2)",
            description: "Kritik sorular",
            topics: [
              "Çözülmemiş Kriz: Kritik sorularla açığa çıkarma",
              "Pratik simülasyonlar"
            ]
          },
          {
            time: "21:45 - 22:45",
            duration: "60 Dk",
            title: "MODÜL 8: En Yüksek Etki - Küresel Vizyon",
            description: "Uygulama ve pekiştirme",
            topics: [
              "Vaka Simülasyonları: Gerçek senaryolarda uygulama",
              "Mimarın Görev Tanımı: Gücü etiğiyle kullanma"
            ]
          },
          {
            time: "22:45 - 24:00",
            duration: "75 Dk",
            title: "BÜYÜK FİNAL: Zihne Fısıldayanlar",
            description: "Zirve ve geri dönülmez değişim",
            topics: [
              "Derin Formatlama: Kalıcı dönüşüm için zihinsel çapalama",
              "Zirve ve Mirasa Çağrı: Mimar yemini",
              "Kapanış ve Sertifika Töreni"
            ]
          }
        ]
      }
    }
  },
  {
    id: 2,
    title: "Zihinsel Değişim ve Dönüşüm",
    subtitle: "Yüzyüze Eğitim",
    description: "Yoğun ve interaktif yüzyüze eğitimle zihinsel dönüşümünüzü tamamlayın. FBI müzakere teknikleri, çerçeveleme protokolü ve derin hipnotik mimari.",
    image: "/assets/images/tanertorun-zfa.png",
    date: "27-28 Aralık 2025",
    time: "10:00 - 18:00",
    duration: "2 Gün, Toplam 16 Saat",
    place: "İstanbul, Şişli",
    price: 25000,
    originalPrice: 35000,
    type: "Yüzyüze",
    features: [
      "FBI Müzakere Teknikleri",
      "Çerçeveleme Protokolü",
      "Siyah Kuğu Metodu",
      "Derin Hipnoz Seansı",
      "Vaka Simülasyonları",
      "Sertifika"
    ],
    detailedProgram: {
      day1: {
        title: "1. GÜN - Kontrol Panelini Kırma ve Yeniden Programlama",
        modules: [
          {
            time: "10:00 - 10:45",
            duration: "45 Dk",
            title: "MODÜL 1: Kendini Sabotajın Gizli Kodları",
            description: "Sistem tanı ve sorunu rasyonelleştirme",
            topics: [
              "Sessizliği Kırma ve zihninizdeki geveze sesi susturma",
              "Termostat Laneti: Mali termostatınızın ayarını sıfırlama",
              "Ferrari Etkisi: Kalıcı yazılım değişikliği"
            ]
          },
          {
            time: "11:00 - 12:30",
            duration: "90 Dk",
            title: "MODÜL 2: Bilinçaltı Sunucusuna Sızma (The Purge)",
            description: "Derin dönüşüm ve kök inanç temizliği",
            topics: [
              "Bağımlılık Zinciri: Zehirli kimyasalları kesme",
              "Cam Kırma Töreni: Yetersizlik kodunu parçalama",
              "Veda ve Devir: Mimar kimliğine geçiş"
            ]
          },
          {
            time: "13:30 - 14:30",
            duration: "60 Dk",
            title: "MODÜL 3: Avatar Yaratımı ve Gerçekliği Yeniden Yazma",
            description: "Kimliği yükseltme ve hızlı uygulama",
            topics: [
              "Süper-Benlik Mimarisi: Karşı konulmaz alter ego tasarlama",
              "Termostat Hack'i: Yeni zihniyet yükleme",
              "Yoda Rolü: Kaçınılmaz rehber konumuna yükselme"
            ]
          },
          {
            time: "14:45 - 16:00",
            duration: "75 Dk",
            title: "MODÜL 4: Kararları Kimin Verdiğini Anlama",
            description: "Gizli mekanizmalar ve sezgisel okuma",
            topics: [
              "Otopilot Kaptanı: Beynin 6 temel dilini okuma",
              "Efsanevi Çilingir: En zor kapıları açma tekniği",
              "Sürüngen Beyin: Nöro-dil kalıpları"
            ]
          },
          {
            time: "16:15 - 17:45",
            duration: "90 Dk",
            title: "MODÜL 5: Bilinçaltına Fısıldama Sanatı (Yasaklanmış Dil)",
            description: "Hipnotik sızma ve gömülü komutlar",
            topics: [
              "Nöbetçiyi Atlatma Protokolü: Eleştirel zihni bypass",
              "Gömülü Komutlar: Bilinçaltı emirleri gönderme",
              "Ön Kabul Köprüsü: Dirençsiz sahiplik hissi"
            ]
          },
          {
            time: "17:45 - 18:00",
            duration: "15 Dk",
            title: "Gün Sonu Değerlendirme",
            description: "Günlük özet ve pekiştirme",
            topics: [
              "Gün içi öğrenilenlerin pekiştirilmesi",
              "Yarına hazırlık"
            ]
          }
        ]
      },
      day2: {
        title: "2. GÜN - Otorite, Güç ve Zirve",
        modules: [
          {
            time: "10:00 - 11:15",
            duration: "75 Dk",
            title: "MODÜL 6: Otorite ve Güç - Çerçeveleme Protokolü",
            description: "Masadaki güç dinamiklerini ele geçirme",
            topics: [
              "Görünmez Güç Savaşı: Çerçeve savaşını kazanma",
              "3 Tuzağın İmhası: Alfa cevaplarla tuzakları tersine çevirme",
              "Siz Ödülsünüz: Kovalanan taraf olma sanatı"
            ]
          },
          {
            time: "11:30 - 12:45",
            duration: "75 Dk",
            title: "MODÜL 7: FBI Müzakere Teknikleri ve Siyah Kuğu",
            description: "Gizli bilgi ve müzakere hakimiyeti",
            topics: [
              "FBI Taktiksel Empati: Siyah Kuğu metodu",
              "7-38-55 Yalan Dedektörü: Beden dili analizi",
              "Çözülmemiş Kriz: Kritik sorularla açığa çıkarma"
            ]
          },
          {
            time: "13:45 - 15:15",
            duration: "90 Dk",
            title: "MODÜL 8: En Yüksek Etki - Küresel Vizyon",
            description: "Uygulama, pekiştirme ve vizyon",
            topics: [
              "Vaka Simülasyonları: Gerçek senaryolarda uygulama",
              "Mimarın Görev Tanımı: Gücü etiğiyle kullanma"
            ]
          },
          {
            time: "15:30 - 18:00",
            duration: "150 Dk",
            title: "BÜYÜK FİNAL: Zihne Fısıldayanlar (The Mind Whisperers)",
            description: "Zirve ve geri dönülmez değişim",
            topics: [
              "Derin Formatlama: Kalıcı dönüşüm için zihinsel çapalama seansı",
              "Zirve ve Mirasa Çağrı: Geri dönülmez zirve noktası ve mimar yemini",
              "Kapanış ve Sertifika Töreni"
            ]
          }
        ]
      }
    }
  }
];

export const expertiseAreas = [
  {
    id: 1,
    name: "Bilinçaltı Programlama",
    tagline: "Zihinsel Yeniden Doğuş: İçsel Mimarinin Estetiği",
    description: "Derin Zihin Teknikleri: Bireyin potansiyelini engelleyen kök inançları zarifçe dönüştürerek, iç huzuru ve kalıcı özgüveni inşa eden, duygusal zekayı merkezine alan ileri seviye yöntemler.",
    icon: "brain"
  },
  {
    id: 2,
    name: "Nöropazarlama",
    tagline: "Markanın Kalp Atışı: Duygusal Bağ Kurma Sanatı",
    description: "Algı Mühendisliği: Tüketici zihnindeki 'satın alma' anını tetikleyen duyusal ve psikolojik tetikleyicileri kullanarak, markanın sadece akılda kalmasını değil, kalpte yer etmesini sağlayan stratejik tasarım.",
    icon: "target"
  },
  {
    id: 3,
    name: "İkna Teknikleri",
    tagline: "Sözün Büyüsü: Zarafetle Etki Alanı Yaratma",
    description: "Duygusal Dil Kalıpları: Karşınızdaki kişinin iç dünyasına uyum sağlayan, güven ve saygı çerçevesinde doğal bir liderlik oluşturan, en zorlu iletişimleri bile ustalıkla yönetme becerisi.",
    icon: "users"
  },
  {
    id: 4,
    name: "İş Stratejileri",
    tagline: "Vizyoner İnşa: Fikrin Ruhu ve Kurumsal İhtişam",
    description: "Teknolojik Strateji ve İnovasyon: Yüksek fayda getiren, kullanıcı deneyimine odaklı yazılım çözümleriyle iş fikrine bir ruh katmak ve teknolojik gelişimi, kurumsal kimliğin zarif bir uzantısı haline getirmek.",
    icon: "lightbulb"
  },
  {
    id: 5,
    name: "Zihinsel Dönüşüm",
    tagline: "Davranışsal Zarafet: Alışkanlıkların Yeniden Yazımı",
    description: "MindLab Metodolojisi: Kendi zihinsel kodlarını keşfederek, kaosu bırakıp amaç odaklı bir düzeni benimseme süreci. Öğrenmekten öte, kişinin en saf potansiyelini hatırlama deneyimi sunar.",
    icon: "sparkles"
  },
  {
    id: 6,
    name: "Derin Öğrenme",
    tagline: "İçsel Keşif: Potansiyelin Görünmez Kaynağı",
    description: "Derin Farkındalık Teknikleri: Zihinsel gürültüyü susturarak, yaratıcılığın ve sezginin görünmez kaynaklarına erişim. Bireyin, kendi en yüksek performansı ile zahmetsizce buluşmasını sağlar.",
    icon: "infinity"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "F.G.",
    title: "Tasarımcı",
    quote: "Bu eğitimi aldıktan sonra hem iş hayatım hem de kişisel ilişkilerim çok daha etkili hale geldi. Hipnotik teknikler gerçekten bir sanat.",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800",
    text: "Bu eğitimi aldıktan sonra hem iş hayatım hem de kişisel ilişkilerim çok daha etkili hale geldi. Hipnotik teknikler gerçekten bir sanat.",
    role: "Tasarımcı"
  },
  {
    id: 2,
    name: "K.L.",
    title: "Satış Uzmanı",
    quote: "Satış uzmanı olarak hipnotik teknikleri öğrenmek benim için büyük bir fark yarattı. Şimdi müşterilerime çok daha etkili bir şekilde ulaşabiliyorum.",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/a509298ade76aceb7981602d54e59d4ce2797c2e-64x64.png",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800",
    text: "Satış uzmanı olarak hipnotik teknikleri öğrenmek benim için büyük bir fark yarattı. Şimdi müşterilerime çok daha etkili bir şekilde ulaşabiliyorum.",
    role: "Satış Uzmanı"
  },
  {
    id: 3,
    name: "A.K.",
    title: "CFO",
    quote: "Taner Hocam'ın bilgeliği ve samimiyeti, eğitimin her dakikasını eşsiz kıldı. Hipnotik tekniklere dair detaylı anlatımları sayesinde zihinsel gücümü yeniden keşfettim.",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/1788ffc0b4a75ba53460163ade9cf7356aff2a1f-64x64.jpg",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800",
    text: "Taner Hocam'ın bilgeliği ve samimiyeti, eğitimin her dakikasını eşsiz kıldı. Hipnotik tekniklere dair detaylı anlatımları sayesinde zihinsel gücümü yeniden keşfettim.",
    role: "CFO"
  },
  {
    id: 4,
    name: "B.Y.",
    title: "CEO",
    quote: "Bu eğitim, sadece bir eğitim değil, adeta bir dönüşüm yolculuğu. Taner Hocam'ın pratik önerileri ve derinlemesine bilgisi beni her açıdan geliştirdi.",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/9936c2e77df67fad433aa078c7dfe90823b07e81-64x64.jpg",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=800",
    text: "Bu eğitim, sadece bir eğitim değil, adeta bir dönüşüm yolculuğu. Taner Hocam'ın pratik önerileri ve derinlemesine bilgisi beni her açıdan geliştirdi.",
    role: "CEO"
  },
  {
    id: 5,
    name: "G.H.",
    title: "İş İnsanı",
    quote: "Eğitim bittiğinde, zihinsel olarak bambaşka bir seviyedeydim. Telkinler, indüksiyonlar, trans derinleştirme... Taner Hocam sayesinde hepsinde ustalaştım!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800",
    text: "Eğitim bittiğinde, zihinsel olarak bambaşka bir seviyedeydim. Telkinler, indüksiyonlar, trans derinleştirme... Taner Hocam sayesinde hepsinde ustalaştım!",
    role: "İş İnsanı"
  },
  {
    id: 6,
    name: "L.M.",
    title: "İletişim Uzmanı",
    quote: "Trans teknikleri ve hipnotik dil kalıpları hayatımı değiştirdi. Artık daha etkili iletişim kuruyor ve bilinçaltımı daha iyi yönetebiliyorum.",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/1788ffc0b4a75ba53460163ade9cf7356aff2a1f-64x64.jpg",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800",
    text: "Trans teknikleri ve hipnotik dil kalıpları hayatımı değiştirdi. Artık daha etkili iletişim kuruyor ve bilinçaltımı daha iyi yönetebiliyorum.",
    role: "İletişim Uzmanı"
  },
  {
    id: 7,
    name: "M.T.",
    title: "Girişimci",
    quote: "Bilinçaltı programlama teknikleri sayesinde hedeflerime çok daha hızlı ulaşıyorum. Taner Hocam'ın öğrettiği yöntemler inanılmaz etkili!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/9936c2e77df67fad433aa078c7dfe90823b07e81-64x64.jpg",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800",
    text: "Bilinçaltı programlama teknikleri sayesinde hedeflerime çok daha hızlı ulaşıyorum. Taner Hocam'ın öğrettiği yöntemler inanılmaz etkili!",
    role: "Girişimci"
  },
  {
    id: 8,
    name: "S.K.",
    title: "Pazarlama Müdürü",
    quote: "Nöropazarlama ve ikna teknikleri eğitimden sonra kampanyalarımızın başarı oranı %40 arttı. Müthiş bir deneyim!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1573497019236-17f8177b81e8?w=800",
    text: "Nöropazarlama ve ikna teknikleri eğitimden sonra kampanyalarımızın başarı oranı %40 arttı. Müthiş bir deneyim!",
    role: "Pazarlama Müdürü"
  },
  {
    id: 9,
    name: "E.D.",
    title: "Koç",
    quote: "Hipnoterapi eğitimi aldıktan sonra müşterilerime çok daha derin seviyede yardımcı olabiliyorum. Hayat değiştiren bir eğitim!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/a509298ade76aceb7981602d54e59d4ce2797c2e-64x64.png",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800",
    text: "Hipnoterapi eğitimi aldıktan sonra müşterilerime çok daha derin seviyede yardımcı olabiliyorum. Hayat değiştiren bir eğitim!",
    role: "Koç"
  },
  {
    id: 10,
    name: "R.A.",
    title: "Yönetici",
    quote: "Ekip yönetiminde ve liderlikte öğrendiğim teknikler sayesinde çok daha etkili bir lider oldum. Taner Hocam'a çok teşekkürler!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/1788ffc0b4a75ba53460163ade9cf7356aff2a1f-64x64.jpg",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800",
    text: "Ekip yönetiminde ve liderlikte öğrendiğim teknikler sayesinde çok daha etkili bir lider oldum. Taner Hocam'a çok teşekkürler!",
    role: "Yönetici"
  },
  {
    id: 11,
    name: "D.Y.",
    title: "Psikolog",
    quote: "Bilinçaltı dönüşüm teknikleri benim için profesyonel bir dönüm noktası oldu. Hastalarımla çalışırken çok daha etkili sonuçlar alıyorum.",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/9936c2e77df67fad433aa078c7dfe90823b07e81-64x64.jpg",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800",
    text: "Bilinçaltı dönüşüm teknikleri benim için profesyonel bir dönüm noktası oldu. Hastalarımla çalışırken çok daha etkili sonuçlar alıyorum.",
    role: "Psikolog"
  },
  {
    id: 12,
    name: "C.B.",
    title: "Danışman",
    quote: "Taner Hocam'ın eğitimi sayesinde hem kişisel hem de profesyonel hayatımda büyük değişimler yaşadım. Her şey için minnettarım!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=800",
    text: "Taner Hocam'ın eğitimi sayesinde hem kişisel hem de profesyonel hayatımda büyük değişimler yaşadım. Her şey için minnettarım!",
    role: "Danışman"
  },
  {
    id: 13,
    name: "N.Ö.",
    title: "İnsan Kaynakları Müdürü",
    quote: "Bilinçaltı programlama teknikleri ile çalışanlarımızın motivasyonunu %60 artırdık. İnanılmaz sonuçlar!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/a509298ade76aceb7981602d54e59d4ce2797c2e-64x64.png",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800",
    text: "Bilinçaltı programlama teknikleri ile çalışanlarımızın motivasyonunu %60 artırdık. İnanılmaz sonuçlar!",
    role: "İnsan Kaynakları Müdürü"
  },
  {
    id: 14,
    name: "H.K.",
    title: "Avukat",
    quote: "Mahkeme salonlarında ikna teknikleri sayesinde davalarımda çok daha başarılı oluyorum. Hayatımı değiştiren bir eğitim!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/1788ffc0b4a75ba53460163ade9cf7356aff2a1f-64x64.jpg",
    image: "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=800",
    text: "Mahkeme salonlarında ikna teknikleri sayesinde davalarımda çok daha başarılı oluyorum. Hayatımı değiştiren bir eğitim!",
    role: "Avukat"
  },
  {
    id: 15,
    name: "Z.A.",
    title: "Yoga Eğitmeni",
    quote: "Hipnoterapi ve meditasyon teknikleri öğrencilerime çok daha derin bir deneyim yaşatmamı sağladı. Muhteşem!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/9936c2e77df67fad433aa078c7dfe90823b07e81-64x64.jpg",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800",
    text: "Hipnoterapi ve meditasyon teknikleri öğrencilerime çok daha derin bir deneyim yaşatmamı sağladı. Muhteşem!",
    role: "Yoga Eğitmeni"
  },
  {
    id: 16,
    name: "U.T.",
    title: "Doktor",
    quote: "Hastalarımla iletişimde öğrendiğim hipnotik dil kalıpları tedavi sürecini hızlandırdı. Taner Hocam'a sonsuz teşekkürler!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800",
    text: "Hastalarımla iletişimde öğrendiğim hipnotik dil kalıpları tedavi sürecini hızlandırdı. Taner Hocam'a sonsuz teşekkürler!",
    role: "Doktor"
  },
  {
    id: 17,
    name: "P.S.",
    title: "Emlakçı",
    quote: "Satış görüşmelerinde bilinçaltı etkileme teknikleri sayesinde kapanış oranım 3 katına çıktı. Herkese tavsiye ederim!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/1788ffc0b4a75ba53460163ade9cf7356aff2a1f-64x64.jpg",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800",
    text: "Satış görüşmelerinde bilinçaltı etkileme teknikleri sayesinde kapanış oranım 3 katına çıktı. Herkese tavsiye ederim!",
    role: "Emlakçı"
  },
  {
    id: 18,
    name: "V.Y.",
    title: "Sosyal Medya Uzmanı",
    quote: "Nöropazarlama prensipleri ile hazırladığım kampanyalar viral oldu. Etkileşim oranlarımız inanılmaz arttı!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/a509298ade76aceb7981602d54e59d4ce2797c2e-64x64.png",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800",
    text: "Nöropazarlama prensipleri ile hazırladığım kampanyalar viral oldu. Etkileşim oranlarımız inanılmaz arttı!",
    role: "Sosyal Medya Uzmanı"
  },
  {
    id: 19,
    name: "İ.M.",
    title: "Akademisyen",
    quote: "Öğrencilerimle kurduğum bağ ve ders anlatım kalitem katlanarak arttı. Bilinçaltı iletişim teknikleri harika!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/9936c2e77df67fad433aa078c7dfe90823b07e81-64x64.jpg",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=800",
    text: "Öğrencilerimle kurduğum bağ ve ders anlatım kalitem katlanarak arttı. Bilinçaltı iletişim teknikleri harika!",
    role: "Akademisyen"
  },
  {
    id: 20,
    name: "Ş.D.",
    title: "Restoran Sahibi",
    quote: "Müşteri deneyimini iyileştirmek için kullandığım nöropazarlama teknikleri satışlarımı ikiye katladı!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800",
    text: "Müşteri deneyimini iyileştirmek için kullandığım nöropazarlama teknikleri satışlarımı ikiye katladı!",
    role: "Restoran Sahibi"
  },
  {
    id: 21,
    name: "Ç.G.",
    title: "Sporcu",
    quote: "Zihinsel kondisyon ve performans artırma teknikleri ile rekorlarımı kırdım. Taner Hocam sayesinde zirvedeyim!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/1788ffc0b4a75ba53460163ade9cf7356aff2a1f-64x64.jpg",
    image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=800",
    text: "Zihinsel kondisyon ve performans artırma teknikleri ile rekorlarımı kırdım. Taner Hocam sayesinde zirvedeyim!",
    role: "Sporcu"
  },
  {
    id: 22,
    name: "Ö.E.",
    title: "Yazılım Geliştirici",
    quote: "Bilinçaltı odaklanma teknikleri ile kodlama hızım ve kalitem müthiş arttı. Konsantrasyon sorunları tamamen bitti!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/9936c2e77df67fad433aa078c7dfe90823b07e81-64x64.jpg",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800",
    text: "Bilinçaltı odaklanma teknikleri ile kodlama hızım ve kalitem müthiş arttı. Konsantrasyon sorunları tamamen bitti!",
    role: "Yazılım Geliştirici"
  },
  {
    id: 23,
    name: "T.K.",
    title: "Muhasebeci",
    quote: "Stres yönetimi ve bilinçaltı rahatlama teknikleri sayesinde iş hayatım çok daha huzurlu. Harika bir deneyim!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/a509298ade76aceb7981602d54e59d4ce2797c2e-64x64.png",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800",
    text: "Stres yönetimi ve bilinçaltı rahatlama teknikleri sayesinde iş hayatım çok daha huzurlu. Harika bir deneyim!",
    role: "Muhasebeci"
  },
  {
    id: 24,
    name: "Y.R.",
    title: "Mimar",
    quote: "Yaratıcılığımı ve hayal gücümü geliştiren bilinçaltı teknikleri projelerime farklı bir boyut kattı. Mükemmel!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800",
    text: "Yaratıcılığımı ve hayal gücümü geliştiren bilinçaltı teknikleri projelerime farklı bir boyut kattı. Mükemmel!",
    role: "Mimar"
  },
  {
    id: 25,
    name: "O.H.",
    title: "Müzisyen",
    quote: "Sahne performansım ve özgüvenim bu eğitimden sonra bambaşka bir seviyeye ulaştı. Taner Hocam muhteşem!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/1788ffc0b4a75ba53460163ade9cf7356aff2a1f-64x64.jpg",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800",
    text: "Sahne performansım ve özgüvenim bu eğitimden sonra bambaşka bir seviyeye ulaştı. Taner Hocam muhteşem!",
    role: "Müzisyen"
  },
  {
    id: 26,
    name: "Ğ.P.",
    title: "Hemşire",
    quote: "Hastaları sakinleştirmek için kullandığım hipnotik teknikler gerçekten etkili. İyileşme süreçleri hızlandı!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/9936c2e77df67fad433aa078c7dfe90823b07e81-64x64.jpg",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800",
    text: "Hastaları sakinleştirmek için kullandığım hipnotik teknikler gerçekten etkili. İyileşme süreçleri hızlandı!",
    role: "Hemşire"
  },
  {
    id: 27,
    name: "J.L.",
    title: "Grafik Tasarımcı",
    quote: "Nöropazarlama prensipleri ile tasarladığım afişler ve reklamlar çok daha etkili oldu. Müşterilerim çok memnun!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/a509298ade76aceb7981602d54e59d4ce2797c2e-64x64.png",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800",
    text: "Nöropazarlama prensipleri ile tasarladığım afişler ve reklamlar çok daha etkili oldu. Müşterilerim çok memnun!",
    role: "Grafik Tasarımcı"
  },
  {
    id: 28,
    name: "W.N.",
    title: "Yazar",
    quote: "Yaratıcı blokajlarımı aşmak için öğrendiğim bilinçaltı teknikleri ile kitabımı 3 ayda tamamladım. İnanılmaz!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800",
    text: "Yaratıcı blokajlarımı aşmak için öğrendiğim bilinçaltı teknikleri ile kitabımı 3 ayda tamamladım. İnanılmaz!",
    role: "Yazar"
  },
  {
    id: 29,
    name: "Q.F.",
    title: "Eczacı",
    quote: "Müşteri iletişiminde hipnotik dil kalıpları kullanarak danışmanlık hizmetimi çok daha etkili hale getirdim!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/1788ffc0b4a75ba53460163ade9cf7356aff2a1f-64x64.jpg",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800",
    text: "Müşteri iletişiminde hipnotik dil kalıpları kullanarak danışmanlık hizmetimi çok daha etkili hale getirdim!",
    role: "Eczacı"
  },
  {
    id: 30,
    name: "X.Ş.",
    title: "Event Planner",
    quote: "Müşterilerle ilk görüşmede kuracağım bağ için kullandığım teknikleri öğrendim. Sözleşme oranım %80'e çıktı!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/9936c2e77df67fad433aa078c7dfe90823b07e81-64x64.jpg",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800",
    text: "Müşterilerle ilk görüşmede kuracağım bağ için kullandığım teknikleri öğrendim. Sözleşme oranım %80'e çıktı!",
    role: "Event Planner"
  },
  {
    id: 31,
    name: "B.V.",
    title: "Fitness Antrenörü",
    quote: "Müşterilerimin motivasyonunu artırmak için bilinçaltı programlama harika sonuçlar verdi. Hedeflere ulaşma oranı arttı!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/a509298ade76aceb7981602d54e59d4ce2797c2e-64x64.png",
    image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=800",
    text: "Müşterilerimin motivasyonunu artırmak için bilinçaltı programlama harika sonuçlar verdi. Hedeflere ulaşma oranı arttı!",
    role: "Fitness Antrenörü"
  },
  {
    id: 32,
    name: "Ü.Z.",
    title: "Terzi",
    quote: "Müşteri memnuniyetini artırmak için kullandığım ikna teknikleri siparişlerimi ikiye katladı. Taner Hocam'a teşekkürler!",
    avatar: "https://cdn.sanity.io/images/nyyhaljw/production/c468e8ceb1525755d095d5e49a6ba55ec763f139-64x64.jpg",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800",
    text: "Müşteri memnuniyetini artırmak için kullandığım ikna teknikleri siparişlerimi ikiye katladı. Taner Hocam'a teşekkürler!",
    role: "Terzi"
  }
];

export const companyLogos = [
  {
    id: 1,
    name: "Medyatik Yazılım A.Ş.",
    description: "Yenilikçi Ar-Ge projeleri ile dijital dönüşümün öncüsü"
  },
  {
    id: 2,
    name: "Medyatik Interactive 360",
    description: "Nöropazarlama ilkeleriyle marka hikayelerini hayata geçiren kreatif güç"
  },
  {
    id: 3,
    name: "MindLab Academy",
    description: "Zihinsel yazılımları yeniden yazan, dönüşüm uyanışının merkezi"
  },
  {
    id: 4,
    name: "Kocaeli Üniversitesi Teknopark",
    description: "Bilim ve inovasyonun buluştuğu stratejik Ar-Ge üssü"
  }
];

export const stats = [
  {
    id: 1,
    value: "5000+",
    label: "Katılımcı"
  },
  {
    id: 2,
    value: "15+",
    label: "Yıl Deneyim"
  },
  {
    id: 3,
    value: "3",
    label: "Şirket"
  },
  {
    id: 4,
    value: "100%",
    label: "Memnuniyet"
  }
];
